export default {
    props: {
        value: {
            type: Object,
            required: true,
        },
        selectedMap: {
            type: Object,
            required: true,
        },
        selectableGroups: {
            type: Boolean,
            default: false,
        },
        flatGroups: {
            type: Boolean,
            default: false,
        },
        level: {
            type: Number,
            default: 1,
        },
    },
    data() {
        return {
            collapsed: true,
        };
    },
    computed: {
        optionCssClasses() {
            return {
                flat: this.flatGroups,
                hasnested: this.hasNested,
                collapsed: this.collapsed,
                ['level-' + this.level]: true,
            };
        },
        headerCssClasses() {
            return {
                disabled: this.value.disabled,
            };
        },
        hasNested() {
            return this.value.nested.length > 0;
        },
        checked() {
            return !!this.selectedMap[this.value.key];
        },
        selectable() {
            return !this.hasNested || this.selectableGroups;
        },
    },
    methods: {
        toggle() {
            this.collapsed = !this.collapsed;
        },
        select() {
            if (this.selectable) {
                this.$emit('selected', this.value);
            } else {
                this.toggle();
            }
        },
    },
};
